import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'roblexMaskNumberAccount',
})
export class MaskNumberAccountPipe implements PipeTransform {
    /**
     * Creates an instance of country pipe.
     */
    constructor() {}
    /**
     * Transforms country pipe
     * @param value string
     * @returns string
     */
    transform(value: string | undefined): string {
        return value ? `****${value.substr(value.length - 4)}` : '';
    }
}
